var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('lottie-player',{staticClass:"margin-bottom-m",attrs:{"src":"/animations/new-brand-loader.json","autoplay":"","loop":"","preserveAspectRatio":"xMidYMax slice"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }